import axios from '../utilities/axios'
import { findWebGL } from '../utilities/webGL'

const downloadPvtFile = async function downloadPvt() {
  const os = decectOS()
  let downloadUrl
  let filename
  let response
  if (os === 'MacOS' || os === 'Unknown OS') {
    throw new Error('error.pvt.unsupportOS')
  } else if (os === 'Windows') {
    downloadUrl = '/api/v1/pvt/download'
    const filenameResponse = await axios.post('/api/v1/pvt/filename', { gpu: findWebGL() })
    filename = filenameResponse.filename
    response = await axios.get(downloadUrl, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
  } else if (os === 'Linux' || os === 'UNIX') {
    const gpu = findWebGL()
    downloadUrl = `api/v1/pvt/download-linux?gpu=${gpu}`
    filename = 'pvt.sh'

    response = await axios.get(downloadUrl, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
  }

  const blob = new Blob([response], { type: 'application/octet-stream' })

  if (navigator && navigator.msSaveBlob && navigator.userAgent.indexOf('Edge') === -1) {
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    link.style.display = 'none'
    document.body.appendChild(link)
    link.href = URL.createObjectURL(blob)
    link.download = filename
    link.click()
    link.remove()
  }
}

function decectOS() {
  let oSName = 'Unknown OS'
  // TODO: need to check active way for determining the OS
  if (navigator.appVersion.indexOf('Win') !== -1) oSName = 'Windows'
  else if (navigator.appVersion.indexOf('X11') !== -1) oSName = 'UNIX'
  else if (navigator.appVersion.indexOf('Linux') !== -1) oSName = 'Linux'
  else if (navigator.appVersion.indexOf('Mac') !== -1) oSName = 'MacOS'
  return oSName
}

export default {
  downloadPvtFile,
}
